export default class AttachmentCommand {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.entityId = item != null ? item.entityId : ''
        this.name = item != null ? item.name : ''
        this.path = item != null ? item.path : ''
        this.content = item != null ? item.content : new File([], '')
    }
}